import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';

export const getDBBitStatus = createAsyncThunk('bitPayment/getDBBitStatus', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getDBBitStatus', [data]);
    return result.Body;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.error);
  }
});

export const createBitRequest = createAsyncThunk('bitPayment/createBitRequest', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('createBitRequest', [
      data.ban,
      data.paymentSubject,
      data.paymentAmount,
      data.customerEmail,
      data.billByEmail,
      data.device,
      data.totalAmount,
    ]);
    return result.Body;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.error);
  }
});

export const bitStatusValidation = createAsyncThunk('bitPayment/bitStatusValidation', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('bitStatusValidation', [data.ban, data.externalSystemReference, data.onPending]);
    return result.Body;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.error);
  }
});

export const getCurrentPaymentStatus = createAsyncThunk('bitPayment/getCurrentPaymentStatus', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getCurrentPaymentStatus', [
      data.ban,
      data.externalSystemReference,
      data.onPending,
    ]);
    return result.Body;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.error);
  }
});

const initialState = {
  loading: false,
  isReady: false,
  error: false,
  errorDescription: '',
  externalSystemReference: '',
  paymentInitiationId: '',
  transactionSerialId: '',
  status: '',
  statusCode: '',
  linkIphone: '',
  linkAndroid: '',
  showPopup: false,
  reuse: false,
  intervalId: ''
};

const bitPaymentSlice = createSlice({
  name: 'bitPayment',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    closePopup: (state, action) => {
      state.showPopup = false;
      state.isReady = false;
    },
    openPopup: (state, action) => {
      state.showPopup = true;
    },
    setReuse: (state, action) => {
      state.reuse = action.payload;
    },
    setIntervalId: (state, action) => {
      state.intervalId = action.payload;
    }
  },
  extraReducers: {
    [getDBBitStatus.pending]: (state, action) => {
      state.loading = true;
    },
    [getDBBitStatus.fulfilled]: (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
    },
    [getDBBitStatus.rejected]: (state, action) => {
      state.error = true;
      state.errorDescription = action.error.name;
    },
    [createBitRequest.pending]: (state, action) => {
      state.loading = true;
      state.error = false;
      state.errorDescription = '';
      state.externalSystemReference = '';
      state.transactionSerialId = '';
      state.paymentInitiationId = '';
      state.isReady = false;
      state.showPopup = false;
    },
    [createBitRequest.fulfilled]: (state, action) => {
      state.loading = false;

      if (action.payload?.error) {
        state.error = true;
        state.errorDescription = action.payload.errorDescription;
        return state;
      }
      state.externalSystemReference = action.payload.externalSystemReference;
      state.transactionSerialId = action.payload.transactionSerialId;
      state.paymentInitiationId = action.payload.paymentInitiationId;
      state.linkIphone = action.payload.linkIphone;
      state.linkAndroid = action.payload.linkAndroid;
      state.isReady = true;
      state.reuse = true;
    },
    [bitStatusValidation.pending]: (state, action) => {
      state.loading = true;
      state.error = false;
      state.errorDescription = '';
    },
    [bitStatusValidation.fulfilled]: (state, action) => {
      state.loading = false;
      if (action.payload?.error) {
        state.error = true;
        state.errorDescription = action.payload.errorDescription;
        return state;
      }
      state.status = action.payload.status;
    },
    [getCurrentPaymentStatus.fulfilled]: (state, action) => {
      state.status = action.payload.status;
      return state;
    },
  },
});

// export const { resetBlock, //openBitIframe, setCancelBitPopup// } =
export const { resetBlock, closePopup, setReuse, openPopup, setIntervalId } = bitPaymentSlice.actions;
export default bitPaymentSlice.reducer;
